<template>
  <div class="invoice__payment">
    <div class="invoice__payment -bg" @click="close"></div>
    <div class="invoice__payment-alert">
      <div class="row h-100">
        <div class="col-12" v-if="scope === 'setting'">
          <div class="text-center mt-30">
            <h4 class="mt-30 mb-20">
              Payment Methods
              <img
                class="close-btn"
                src="~@/assets/media/icons/close.svg"
                alt="close icon"
                @click="close"
              />
            </h4>
            <TabDropdown
              v-model="payment"
              :dropdownItems="paymentMethods"
              placeholder="Please choose payment method"
            />
            <div class="invoice__payment-content">
              <template v-if="payment !== 'credit'">
                <p>Total Amount: {{ invoice.totalAmount }}</p>
                <span class="font-size-xs"
                  >Click submit to change the status to paid</span
                >
              </template>
              <template v-if="payment === 'credit'">
                <Paypal
                  :invoice="invoice"
                  :amount="invoice.totalAmount.toString()"
                  @approved="handleSubmit"
                />
                <p class="my-20">Total Amount: {{ invoice.totalAmount }}</p>
              </template>
            </div>
            <div
              class="invoice__payment-buttons mt-10 d-flex justify-content-center"
            >
              <ActionButton
                :theme="{ primary, secondary, danger, event }"
                @customEvent="close"
                class="mr-10 mt-0 w-auto"
                label="Close"
              />
              <ActionButton
                v-if="payment != 'credit'"
                :theme="{ primary, secondary, danger, event }"
                @customEvent="submit"
                :class="
                  !payment || approved === false
                    ? 'invoice__payment-disabled'
                    : ''
                "
                class="m-0 d-inline w-auto"
              />
            </div>
          </div>
        </div>
        <div class="col-12" v-else-if="scope === 'user'">
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
            class="close-btn"
            v-if="methodDetails.status != 2"
          />
          <div class="row" v-if="methodDetails.status == 0">
            <div class="col-12">
              <h5 class="mb-20 payment-title">How would you like to pay?</h5>
              <div
                class="row"
                v-if="
                  paymentOptions &&
                    paymentOptions[0] &&
                    paymentOptions[0].value == 'stripe'
                "
              >
                <Stripe
                  :invoice="invoice"
                  :amount="invoice.totalAmount.toString()"
                  @approved="handleSubmit"
                  @customEvent="close"
                />
              </div>
              <Paypal
                v-else-if="
                  paymentOptions &&
                    paymentOptions[0] &&
                    paymentOptions[0].value == 'paypal'
                "
                :invoice="invoice"
                :amount="invoice.totalAmount.toString()"
                @approved="handleSubmit"
                class="mr-2"
              />
              <div
                class="d-flex option-single"
                v-else
                @click="handleChosenOption(singleOption)"
              >
                <img
                  :src="singleOption.icon"
                  alt="icon"
                  style="max-width: 20px"
                />
                <span>
                  {{ singleOption.name }}
                </span>
              </div>
              <div v-if="paymentOptions.length > 1">
                <hr class="invoice__payment-divider" />
                <span class="divider-header">Other Payment Options</span>
                <div class="invoice__payment-options">
                  <template v-for="(methods, i) in paymentOptions">
                    <div :key="i">
                      <div
                        class="options-list"
                        v-if="
                          methods.value != 'stripe' &&
                            methods.value != 'paypal' &&
                            !methods.disabled &&
                            i > 0
                        "
                        @click="handleChosenOption(methods)"
                      >
                        <img
                          :src="methods.icon"
                          alt="icon"
                          style="max-width: 20px"
                        />
                        <span>
                          {{ methods.name }}
                        </span>
                      </div>
                      <Paypal
                        v-if="
                          paymentOptions &&
                            paymentOptions[0] &&
                            paymentOptions[0].value != 'paypal' &&
                            methods.value == 'paypal' &&
                            !methods.disabled
                        "
                        :invoice="invoice"
                        :amount="invoice.totalAmount.toString()"
                        @approved="handleSubmit"
                        class="mr-2"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else-if="methodDetails.status == 1">
            <div class="col-12 method-details">
              <h5 class="mb-20 payment-title">
                <a
                  href="#"
                  class="checkout__link"
                  @click="handleBack($event, 0)"
                  v-if="isPaymentMethod.length > 1 && paymentOptions.length > 1"
                >
                  <img
                    src="@/assets/media/icons/back_colored.svg"
                    alt="back arrow"
                  />
                </a>
                {{ methodDetails.label }}
              </h5>
              <div class="ql-editor" v-html="methodDetails.description"></div>
              <ActionButton
                :theme="{ primary, secondary, event, danger }"
                class="w-auto ml-auto m-0"
                style="padding: 15px 20px;"
                label="Ok"
                @customEvent="handleBack($event, 2)"
              />
            </div>
          </div>
          <div class="row" v-else-if="methodDetails.status == 2">
            <div class="col-12 proceed-details">
              <span>
                Please note that your invoice is considered
                <span class="disabled">unpaid</span>
                until payment has been made.
              </span>
              <span>
                If you want to complete your transaction now, you may choose to
                pay via credit card.
              </span>
              <ActionButton
                :theme="{ primary, secondary, event, danger }"
                class="w-auto ml-auto m-0"
                style="padding: 15px 20px;"
                label="Ok"
                @customEvent="handleBack($event, 3)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabDropdown from "@/components/TabDropdown";
import axios from "@/helpers/axios";
import Paypal from "@/components/invoice/payments/Paypal";
import { socketSender } from "@/helpers/socket";
import { paymentConfirmEmail, paymentConfirmToOwner } from "@/helpers/mailer";
import ActionButton from "@/components/ActionButton";
import _ from "lodash";
import Stripe from "@/components/invoice/payments/Stripe";

// import stripe from "@/helpers/payments/stripe";
// import stripeKey from "@/helpers/payments/stripeKey";

export default {
  components: {
    TabDropdown,
    Paypal,
    Stripe,
    ActionButton
  },
  props: {
    invoice: {
      type: [Object],
      default: null
    },
    scope: {
      type: [String],
      default: null
    }
  },
  data() {
    return {
      payment: null,
      paymentMethods: [],
      paymentOptions: [],
      approved: false,
      isPaymentMethod: [],
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName,
      card: {
        cvc: "",
        number: "",
        expiry: ""
      },
      stripeError: "",
      methodDetails: {
        status: 0
      },
      singleOption: {},
      defaultCashDescription:
        "Please provide your cash payment at the concierge upon arrival."
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  watch: {
    payment() {
      this.approved = false;
      if (this.payment !== "credit") {
        this.approved = true;
      }
    }
  },
  methods: {
    async handleSubmit(data) {
      this.approved = false;
      var orderMeta;
      if (data.paymentType == "Stripe") {
        let brand = data.response.payment_method_details.card.brand;
        let type = data.response.payment_method_details.type;
        let stripeChargeId = data.response.id;
        let payment = `Stripe`;
        this.payment = payment;
        orderMeta = [
          {
            key: "paymentMethod",
            value: payment,
            label: "Payment Method"
          },
          {
            key: "stripeChargeId",
            value: stripeChargeId,
            label: "Stripe Charge ID"
          },
          {
            key: "Type",
            value: type,
            label: "Payment method details"
          },
          {
            key: "Brand",
            value: brand
          }
        ];
      } else if (this.payment === "credit" || this.scope === "user") {
        this.payment = "Paypal Credit";
        orderMeta = [
          { key: "paymentMethod", value: "paypal", label: "Payment Method" },
          { key: "paypalId", value: data.id, label: "Paypal ID" },
          {
            key: "paypalStatus",
            value: data.payer.status,
            label: "Paypal Status"
          },
          { key: "paypalCart", value: data.cart, label: "Paypal Cart" }
        ];
      }

      if (orderMeta) {
        for (var meta of orderMeta) {
          await axios
            .post(`/orders/${this.invoice.id}/meta`, meta)
            .then(response => {
              return response.data;
            });
        }
        this.approved = true;
        this.payOrder();
      }
    },
    close() {
      this.$emit("close");
    },
    async submit() {
      const invoice = JSON.parse(JSON.stringify(this.invoice));
      if (invoice && this.payment) {
        const orders = this.invoice.OrderPackages;
        var isavailable = true;
        for (var order of orders) {
          const id = order.Package.productId;
          await axios
            .get(
              `/products/${id}/availability?qp[start]=${order.startAt}&qp[end]=${order.endAt}&qp[op]=${order.id}`
            )
            .then(response => {
              const available = response.data.available;
              if (available === false) {
                isavailable = false;
              }
            });
        }
        if (isavailable) {
          this.$swal({
            title: "Are you sure?",
            text: "Do you want to set this order to paid?",
            type: "info",
            showCancelButton: true,
            confirmButtonText: "Yes, submit",
            reverseButtons: true
          }).then(async result => {
            if (result.value) {
              this.payOrder();
            }
          });
        } else {
          this.$swal(
            "Warning",
            "Overlapped bookings, please create another order",
            "warning"
          );
        }
      }
    },
    async payOrder() {
      let order = [];
      let orderPackage = this.invoice.OrderPackages;
      if (orderPackage.length) {
        orderPackage.map(e => {
          order.push({
            orderPackage: e,
            product: e.Package.Product.name,
            term: e.Package.Term.name,
            start: e.startAt,
            end: e.endAt
          });
        });
      }
      let systemModule;
      switch (this.$route.name) {
        case "admin-invoice":
          systemModule = "ADMIN";
          break;
        case "concierge-invoice":
          systemModule = "CONCIERGE";
          break;
        default:
          systemModule = "USER";

          break;
      }
      /**
       * SOCKET: Invoice payment log
       */
      let logContent = `${this.invoice.code} for ${this.invoice.User.firstName} ${this.invoice.User.lastName} has been paid via ${this.payment} on ${systemModule}: ${this.currentUser}`;

      await socketSender("paidOrder", logContent);
      axios
        .patch(`/orders/${this.invoice.id}`, {
          paidAt: new Date(),
          paymentMethod: this.payment
        })
        .then(() => {
          this.$emit("reinit");
          this.$emit("close");
        })
        .then(async () => {
          // TODO: Replace store user data to current connected user of the specific invoice.
          // const { email, displayName } = this.$store.getters.getUser;
          const email = this.invoice.User.email;
          const fullName =
            this.invoice.User.firstName + " " + this.invoice.User.lastName;
          await paymentConfirmEmail({
            to: email,
            fullName,
            order,
            invoiceId: this.invoice.id
          });
          await paymentConfirmToOwner({
            details: {
              code: this.invoice.code,
              fullName:
                this.invoice.User.firstName + " " + this.invoice.User.lastName,
              order,
              invoiceId: this.invoice.id
            }
          });
        })
        .catch(console.error);
    },
    handleChosenOption(data) {
      let payment = data;
      let label = payment.name;
      let description = this.defaultCashDescription;
      if (this.isPaymentMethod.length) {
        const payment = _.filter(this.isPaymentMethod, ["label", data.name])[0];
        description = payment.value.description;
      }
      if (payment) {
        this.methodDetails = {
          status: 1,
          label: label,
          description: description
        };
      }
    },
    handleBack(evt, status) {
      let statusCount = status;
      if (status == 0) {
        evt.preventDefault();
      }
      if (status == 3) {
        this.close();
      }
      this.methodDetails = {
        status: statusCount
      };
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions", "paymentoption");

    this.isPaymentMethod = _.filter(this.options, [
      "key",
      "paymentoption.main"
    ]);

    const methods = [
      { value: "stripe", name: "Stripe", disabled: true },
      {
        value: "paypal",
        name: "Paypal",
        disabled: true,
        icon: null
      },
      {
        value: "cash",
        name: "Cash",
        disabled: false,
        icon: require("@/assets/media/icons/dollar.svg")
      },
      {
        value: "brank_transfer",
        name: "Bank Transfer",
        disabled: true,
        icon: require("@/assets/media/icons/bank_icon.svg")
      },
      {
        value: "paymaya",
        name: "PayMaya",
        disabled: true,
        icon: require("@/assets/media/paymaya-logo.png")
      },
      {
        value: "cheque",
        name: "Cheque",
        disabled: true,
        icon: require("@/assets/media/icons/cheque.svg")
      }
    ];

    for (var method of methods) {
      const payments = _.filter(this.isPaymentMethod, ["label", method.name]);
      method.disabled =
        payments.length > 0 ? (payments[0].value.status ? false : true) : true;
    }
    this.paymentMethods = methods;
    this.paymentOptions = _.filter(methods, ["disabled", false]);
    let methodStatus = 0;
    let defaultDescription = this.defaultCashDescription;
    let defaultLabel = "Cash";
    if (this.isPaymentMethod.length && this.paymentOptions.length) {
      this.singleOption = this.paymentOptions[0];
      const newPayment = _.filter(this.isPaymentMethod, [
        "label",
        this.singleOption.name
      ])[0];
      defaultLabel = this.singleOption.name;
      defaultDescription = newPayment.value.description;
    } else {
      this.singleOption = this.paymentMethods[2];
    }

    if (
      this.paymentOptions.length > 1 ||
      (this.paymentOptions[0] &&
        (this.paymentOptions[0].value == "stripe" ||
          this.paymentOptions[0].value == "paypal"))
    ) {
      methodStatus = 0;
    }
    this.methodDetails = {
      status: methodStatus,
      label: defaultLabel,
      description: defaultDescription
    };
  }
};
</script>

<style lang="scss" scoped>
.invoice {
  &__img {
    position: relative;
    img {
      margin: auto;
    }
  }
}
.invoice__payment {
  display: block;
  position: fixed;
  z-index: 1001;
  padding: 10px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  .invoice__instruction {
    font-size: 0.9375rem;
  }
  .close-btn {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: -20px;
    z-index: 1;
    @media (max-width: 575px) {
      right: -25px;
      top: -45px;
    }
  }
  h4 {
    img {
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 0;
    }
  }
  .-bg {
    background: #000;
    content: "";
    opacity: 0.5;
    pointer-events: all;
    z-index: -1;
    height: 100%;
  }
  &-divider {
    border-color: $gray-300;
    margin-bottom: 20px;
  }
  &-options {
    display: flex;
    flex-flow: column wrap;
    position: relative;
    @media (min-width: 768px) {
      align-items: center;
      flex-flow: row wrap;
    }
    > * {
      margin-bottom: 1rem;
      @media (min-width: 768px) {
        margin-bottom: 0;
        &:not(:last-child) {
          margin-right: 0.625rem;
        }
      }
    }
    .options-list {
      font-size: 14px;
      padding: 0;
      cursor: pointer;
      img {
        margin-right: 3px;
      }
      span {
        color: #00b3c1;
        vertical-align: middle;
      }
    }
    &__badge {
      position: absolute;
      top: 0;
      left: -35px;
      font-size: 12px;
      padding: 2px 7px;
      border: 2px solid $brand-primary;
      color: $brand-primary;
      height: 25px;
      width: 25px;
      border-radius: 90px;
    }
  }
  &-buttons {
    left: 0;
    bottom: 0;
    width: 100%;
  }
  &-disabled {
    background: $brand-secondary !important;
    color: $gray-500;
    pointer-events: none;
  }
  &-header {
    margin-bottom: 40px;
    h5 {
      font-size: 24px;
      line-height: 26px;
      margin-bottom: 10px;
    }
    p {
      font-size: 18px;
      line-height: 24px;
    }
  }
  &-alert {
    animation: fade-in-up-data-v-5a453d14 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 50px 50px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    z-index: 1;
    @media (max-width: 767px) {
      width: 500px;
    }
    @media (max-width: 575px) {
      max-width: 500px;
      padding: 60px;
      width: 300px;
    }
    .payment-title {
      font-size: 20px;
      &_header {
        font-size: 14px;
        margin-bottom: 10px;
        display: block;
        font-weight: 500;
      }
    }
    .form-group {
      label {
        font-size: 12px;
      }
    }
    .term-holder {
      font-size: 12px;
      display: block;
      margin-bottom: 10px;
      a {
        color: #00b3c1;
      }
    }
    .method-details {
      .payment-title {
        margin-bottom: 30px !important;
        .checkout__link {
          font-size: 25px;
          margin-right: 10px;
        }
      }
      .ql-editor {
        height: auto;
        margin: 0 -0.9375rem 2rem;
      }
      span {
        font-size: 18px;
        display: block;
        margin-bottom: 10px;
        p {
          margin-bottom: 10px;
        }
      }
      img {
        max-width: 100%;
      }
    }
    .divider-header {
      font-size: 16px;
      margin-bottom: 20px;
      display: block;
    }
    .proceed-details {
      font-size: 18px;
      display: flex;
      flex-direction: column;
      span {
        margin-bottom: 20px;
        &.disabled {
          color: #fa533d;
        }
      }
    }
    .option-single {
      cursor: pointer;
      img {
        margin-right: 5px;
      }
      span {
        color: #00b3c1;
      }
    }
  }
  &-content {
    width: 100%;
    text-align: center;
  }
  &-exit {
    float: right;
    padding: 0;
    height: 0;
  }
}
</style>
